<template>
    <div class="align--center gutter--top download-pdf-container spring" data-html2canvas-ignore="true">
        <h2 class="heading heading--4 heading--light heading--leading heading--center">Descarcă informațiile din pagină în format PDF</h2>
        <a class="button button--primary" @click.prevent="genPDF()" v-html="buttonGenPDFText"></a>
    </div>
</template>

<script>
import * as jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

export default {
    name: 'DownloadAsPdf',
    data() {
        return {
            allowGenPDF: true,
        };
    },
    computed: {
        buttonGenPDFText() {
            return this.allowGenPDF ? 'Descarcă' : 'Se descarcă ...';
        },
    },
    methods: {
        genPDF() {
            // expand collapsibles in parent (ServiceSelector)
            this.$parent.toggle_roaming = true;
            this.$parent.toggle_roaming_extins = true;
            this.$parent.toggle_internet = true;
            this.$parent.toggle_in_slide_1 = true;
            this.$parent.toggle_in_slide_2 = true;
            this.$parent.toggle_in_slide_3 = true;
            this.$parent.toggle_in_slide_4 = true;

            this.$root.$emit('prepare-for-pdf');

            this.$nextTick(() => {
                this.generateAndDownloadPDF();
            });
        },
        generateAndDownloadPDF() {
            var $this = this;

            if (!this.allowGenPDF) return false;
            this.allowGenPDF = false;

            html2canvas($('#app')[0], {
                // useCORS set to true for local testing
                useCORS: true,
            }).then(function (canvas) {
                setTimeout(() => {
                    var width = canvas.width;
                    var height = canvas.height;

                    var pagePDF = {};
                    pagePDF.width = Math.floor(width * 0.264583);
                    pagePDF.height = Math.floor(height * 0.264583);

                    var imgData = canvas.toDataURL('image/png');

                    var pdf = new jsPDF('p', 'mm', 'a4');
                    pdf.deletePage(1);
                    pdf.addPage(pagePDF.width, pagePDF.height);
                    pdf.addImage(imgData, 'PNG', 0, 0);
                    pdf.save('vodafone-roaming' + $this.$route.path.replace(/\//g, '__') + '.pdf');
                    $this.allowGenPDF = true;
                }, 500);
            });
        },
    },
};
</script>
